<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'债权融资申请审核',goback:true},{name:'债权融资申请审核产品详情'}]" :title="'债权融资申请审核产品详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">银行名称：</div>
                        <div class="content">{{detail.bankName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">产品名称：</div>
                        <div class="content">{{detail.debtProductName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">贷款类型：</div>
                        <div class="content">{{detail.loanTypeValue}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">最高额度：</div>
                        <div class="content">{{detail.maxAmount}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">最低额度：</div>
                        <div class="content">{{detail.minAmount}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">担保方式：</div>
                        <div class="content">
                        {{detail.guaranteeWayValue}}
                        <span v-for="(i,index) in detail.guaranteeWay" :key="index">{{i.value}} </span>
                        </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">年利率：</div>
                        <div class="content">{{detail.yearInterest}}%</div>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">产品介绍：</div>
                        <div class="content super_p" v-html="detail.productIntro"></div>
                    </div>
                  </el-col>
                  </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="childMulti">
                        <div class="name">贷款须知：</div>
                        <ul>
                            <li class="content " v-for="(item,index) in detail.loanKnown" :key="index" >
                                <div class="super_html"><span>{{item.sort}}.</span> <div v-html="item.content" class="super_p"></div></div>
                            </li>
                        </ul>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detail.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                                </li>
                            </ul>
                     </div>
                  </el-col>
                </el-row>
              </el-card>
              
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{
                guaranteeWay:[],
                fileList:[],
                loanKnown:[]
            },//数据
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){                                
         const {code,data,msg} = await this.$axiosc.get('backstage/debt/financing/details/'+this.id)
          if (code == 200) {            
              this.detail = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
      .childMulti{
        margin-top:0;
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>